export const ROOT_ENDPOINT_SOCKETS = 'wss=https://origin-dev.lk-s.com/'
export const ROOT_ENDPOINT = 'https://origin-dev.lk-s.com/'
export const MEDIA_AWS_S3_URL = 'https://lks-bucket-origin-dev-static.s3.eu-west-3.amazonaws.com/'
export const MEDIA_AWS_BUCKET_NAME = 'luckysit-dev'
// `auth/token`, `auth/oauth/login`, `users/` (création de compte),
// `auth/password-reset` et `langs` ont disparu : aucune n'existe côté back, et
// plus rien ne les appelait. `users/me/` aussi, qui n'était lu que par un
// `fetchEvent` jamais déclenché. Le spectateur est authentifié comme invité
// (`auth/login/guest`), puis identifié à l'inscription à un jeu.

// GAMES
export const GAME_SETTINGS_ENDPOINT = 'places/:slug/events-games'
// Vues et clics des cartes de jeu (06/10), comme ceux des liens externes
export const GAME_STATS_ENDPOINT = 'events-games/stats'
// URL dédiée par event (/e/:slug) : test/preview + deep-link
export const EVENT_GAMES_BY_SLUG_ENDPOINT = 'events/slug/:slug/events-games'
export const EVENT_BY_SLUG_ENDPOINT = 'events/slug/:slug'

// Live
export const LIVE_SOCKET = 'live'
// Écran + Régie : le tifo piloté (29/09)
export const STAGE_SOCKET = 'stage'

// Quizz
export const LUCKY_QUIZZ_SOCKETS = 'lucky-quizz'
export const LUCKY_QUIZZ_RANKING = 'events-games/:id/lucky-quizz/ranking'

// Score
export const EVENT_GAME_FULL_RANKING = 'events-games/:id/full-ranking'

// Participations : l'inscription (POST), la mienne (GET), jouer (PATCH)
export const PARTICIPATIONS_ENDPOINT = 'events-games/:id/participations'
export const MY_PARTICIPATION_ENDPOINT = 'events-games/:id/participations/me'
/** Le quiz individuel (22/09) : la question suivante, puis la réponse. */
export const SOLO_QUIZZ_NEXT_ENDPOINT = 'events-games/:id/solo-quizz/next'
export const SOLO_QUIZZ_ANSWER_ENDPOINT = 'events-games/:id/solo-quizz/answer'
// Le préremplissage : ce que la personne a déjà saisi dans ce lieu
export const PREFILL_ENDPOINT = 'events-games/:id/participations/prefill'
// Le photobooth : une photo, déposée sous ma participation
export const MY_PHOTOS_ENDPOINT = 'events-games/:id/participations/me/photos'

// Ads
export const ADS_ENDPOINT = 'events/:id/ads/:areaId'
export const AD_STATS_ENDPOINT = 'ads/stats'